/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import HeaderDropdownMenus from '../examples/HeaderDropdownMenus';
import HeaderDropdownCategories from '../examples/HeaderDropdownCategories';
import HeaderDropdownWithLightBackground from '../examples/HeaderDropdownWithLightBackground';
const HeaderDropdownMenusSource = require('!!raw-loader!../examples/HeaderDropdownMenus');
const HeaderDropdownCategoriesSource = require('!!raw-loader!../examples/HeaderDropdownCategories');
const HeaderDropdownWithLightBackgroundSource = require('!!raw-loader!../examples/HeaderDropdownWithLightBackground');
export default class DropdownMenusPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="DropdownMenus"/>

                <h3>Header dropdown menus</h3>
                <div className="docs-example">
                    <HeaderDropdownMenus />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HeaderDropdownMenusSource}</PrismCode>
                </pre>

                <h3>Header Dropdown Categories</h3>
                <div className="docs-example">
                    <HeaderDropdownCategories />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HeaderDropdownCategoriesSource}</PrismCode>
                </pre>

                <h3>Header dropdown with light background</h3>
                <div className="docs-example">
                    <HeaderDropdownWithLightBackground />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HeaderDropdownWithLightBackgroundSource}</PrismCode>
                </pre>
            </div>);
    }
}
